import {ActionReducerMapBuilder} from '@reduxjs/toolkit';

import {transformFilterExpressionDtoToExpressionArray} from 'features/predicate-expression-form-list';

import {IReportConfigurationSliceState} from '../report-configuration-types';
import {loadDrilldownFilter, updateDrilldownFilter} from './dd-filters-configuration-thunks';

export const createDdFiltersConfigurationExtraReducer = (
    builder: ActionReducerMapBuilder<IReportConfigurationSliceState>,
) => {
    builder.addCase(loadDrilldownFilter.fulfilled, (state, {payload: ddFilterData, meta}) => {
        const {
            ddFilterExpressionDto,
            tableReportFilterLookups,
            childReportColumns,
        } = ddFilterData ?? {};

        const {childReportTemplateCode} = meta.arg ?? {};

        if (ddFilterExpressionDto) {
            state.drilldownSettings.ddFilter = transformFilterExpressionDtoToExpressionArray(
                ddFilterExpressionDto,
            );
        }

        state.ddLookups.filters = tableReportFilterLookups;
        if (childReportColumns && childReportTemplateCode) {
            state.ddLookups.tableColumns[childReportTemplateCode] = childReportColumns;
        }
    });
    builder.addCase(updateDrilldownFilter.fulfilled, (state, {meta}) => {
        const {filter} = meta.arg;
        state.drilldownSettings.ddFilter = transformFilterExpressionDtoToExpressionArray(filter);
    });
};

export const createDdFiltersConfigurationReducer = <S extends IReportConfigurationSliceState>() => ({
    purgeDrilldownFilter(
        state: S,
    ) {
        state.drilldownSettings.ddFilter = undefined;
    },
});
